import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsListBoardsBlock extends Component {
  createdAt = new Date();

  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">List all boards</div>
          <div className="text">
            Returns a list of all boards associated with your company, in no particular order.
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">
            A dictionary with a "boards" property that contains an array of board objects.
          </div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/boards/list</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/boards/list"
            body={`\\
    -d apiKey=YOUR_API_KEY`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "boards": [{
    "id": "553c3ef8b8cdcd1501ba1234",
    "created": "${this.createdAt.toISOString()}",
    "isPrivate": true,
    "name": "Feature Requests",
    "postCount": 123,
    "privateComments": false,
    "token": "11111111-2222-3333-4444-555555555555",
    "url": "https://your-company.canny.io/admin/board/feature-requests"
  }, {
    "id": "553c3ef8b8cdcd1501ba1238",
    "created": "${this.createdAt.toISOString()}",
    "isPrivate": false,
    "name": "Bug Reports",
    "postCount": 42,
    "privateComments": true,
    "token": "11111111-2222-3333-4444-555555555555",
    "url": "https://your-company.canny.io/admin/board/bug-reports"
  }]
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
